import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import findLastIndex from 'lodash/findLastIndex';

import SelectField from 'eventbrite_design_system/inputField/SelectField';
import {VALUES_PROP_TYPE} from 'eventbrite_design_system/inputField/constants';

import DateInputTag from './DateInputTag';

import {constants as destinationConstants} from '@eb/destination-utils';

const {
    OTHER_EVENTBRITE_CATEGORY,
} = destinationConstants;

const SELECT_FIELD_STYLE = 'basic';

export default class DateSelect extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        value: PropTypes.string,
        values: VALUES_PROP_TYPE,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        isCustomDateSelected: PropTypes.bool,
        shouldOrderValues: PropTypes.bool,
        handleSelect: PropTypes.func,
        handleClear: PropTypes.func,
    }

    _handleSelect = (selectedDate) => {
        const {handleSelect} = this.props;

        if (handleSelect) {
            handleSelect(selectedDate);
        }
    }

    _handleClear = () => {
        const {handleClear} = this.props;

        if (handleClear) {
            handleClear();
        }
    }

    render() {
        const {
            placeholder,
            id,
            label,
            values,
            value,
            isCustomDateSelected,
            shouldOrderValues,
        } = this.props;

        let displayValues = values.slice(0);

        if (shouldOrderValues) {
            const otherIndex = findLastIndex(displayValues, {value: OTHER_EVENTBRITE_CATEGORY});

            // findLastIndex returns -1 when the condition doesn't match any element in the array.
            // We want to order it only when the condition has at least one match.
            if (otherIndex !== -1) {
                const [otherCategory] = displayValues.splice(otherIndex, 1);

                displayValues = sortBy(displayValues, 'display');
                displayValues.push(otherCategory);
            } else {
                displayValues = sortBy(displayValues, 'display');
            }
        }

        let PROP_MAP = {
            placeholder,
            id,
            label,
            values: displayValues,
            value,
            style: SELECT_FIELD_STYLE,
            onChange: this._handleSelect.bind(value),
        };

        let component = (
            <SelectField {...PROP_MAP} />
        );

        if (isCustomDateSelected) {
            PROP_MAP = {
                children: value,
                isClosable: true,
                isStatic: true,
                onClose: this._handleClear,
            };

            component = (
                <DateInputTag {...PROP_MAP} />
            );
        }

        return component;
    }
}
